export const GROUP_1 = 1;
export const GROUP_2 = 2;
export const GROUP_3 = 3;
export const GROUP_4 = 4;

export const GROUPS = [GROUP_1, GROUP_2, GROUP_3, GROUP_4];
